export default "__VITE_ASSET__DXtYEJgp__"